/* eslint-disable react/prop-types */
import * as HomeEvents from "@/analytics/events/home"
import { WidgetWrapper } from "./WidgetWrapper"
import IconCalendar from "@/assets/clipart/widgets/marketing-icon-calendar.svg"
import IconMegaphone from "@/assets/clipart/widgets/marketing-icon-megaphone.svg"
import ImageCalendar from "@/assets/clipart/widgets/marketing-image-calendar.svg"
import ImageMegaphone from "@/assets/clipart/widgets/marketing-image-megaphone.svg"
import ImageDevice from "@/assets/clipart/widgets/marketing-image-device.svg"
import { WidgetCommonHorizontalContainer } from "@/components/widgets/WidgetCommonContainer"
import {
  type MarketingWidgetIconType,
  type MarketingWidgetImageType,
} from "@/types/marketingWidgetTypes"
import { ActivityIndicator, Linking } from "react-native"
import { type MarketingWidgetType } from "@/generated/graphql"
import EmptyView from "@/components/EmptyView"
import React from "react"
import { createExternalLinkClickedEvent, track } from "@/analytics/events/base"

interface MarketingWidgetProps {
  isLoading: boolean
  marketingData: MarketingWidgetType | null
}

export const MarketingWidget: React.FC<MarketingWidgetProps> = ({
  isLoading,
  marketingData,
}) => {
  if (isLoading) {
    return (
      <ActivityIndicator
        className="flex-1 justify-center items-center"
        size={"small"}
      />
    )
  }
  if (!marketingData) return null

  const { icon, heading, image } = marketingData

  const iconCopy = marketingData.iconCopy ?? ""
  const subHeading = marketingData.subHeading ?? "Explore"
  const ctaCopy = marketingData.ctaCopy ?? "Learn More"
  const externalLink = marketingData.externalLink ?? "#"

  const getMarketingIcon = (iconType: MarketingWidgetIconType) => {
    switch (iconType) {
      case "MEGAPHONE":
        return IconMegaphone
      default:
        return IconCalendar
    }
  }

  const getMarketingImage = (imageType?: MarketingWidgetImageType | null) => {
    switch (imageType) {
      case "MEGAPHONE":
        return ImageMegaphone
      case "DEVICE":
        return ImageDevice
      case "CALENDAR":
        return ImageCalendar
      default:
        return <EmptyView />
    }
  }

  const MarketingIcon = getMarketingIcon(icon)
  const MarketingImage = getMarketingImage(image)

  const onPress = (): void => {
    HomeEvents.marketingWidgetClicked({
      widgetType: "widget-marketing",
      widgetTitle: heading,
      widgetCta: ctaCopy,
    })
    // marketingContentView("Home")
    void Linking.openURL(externalLink || "#")
    const urlToOpen: string = externalLink || "#"
    void Linking.openURL(urlToOpen)
    track(
      createExternalLinkClickedEvent({
        current_screen: "Home",
        to_screen: "Ext:Marketing Content",
        component_type: "widget-marketing",
        link_text: ctaCopy,
        link_url: urlToOpen,
      })
    )
  }

  return (
    <WidgetWrapper
      category="marketing"
      orientation="horizontal"
      title={iconCopy}
      onPress={onPress}
    >
      <WidgetCommonHorizontalContainer
        layoutType="tall"
        IconComponent={MarketingIcon}
        ImageComponent={MarketingImage as React.ElementType}
        iconCopy={iconCopy}
        title={heading}
        subTitle={subHeading}
        ctaText={ctaCopy}
      />
    </WidgetWrapper>
  )
}
